var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreativeCommonZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 496,
    viewBox: "0 0 496 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.6 0C389.4 0 496 110.1 496 248C496 395.1 377.5 496 247.6 496C113.6 496 0 386.5 0 248C0 115.1 104.7 0 247.6 0ZM248.4 44.7C130.2 44.7 44.7 142.6 44.7 248C44.7 357.8 135.9 450.8 248.4 450.8C351.6 450.8 451.2 369.7 451.2 248C451.3 134.2 361 44.7 248.4 44.7ZM248 105.2C166.1 105.2 145.5 182.5 145.5 248C145.5 313.5 166.1 390.8 248 390.8C329.9 390.8 350.5 313.5 350.5 248C350.5 182.5 329.9 105.2 248 105.2ZM248 159.1C251.3 159.1 254.4 159.6 257.2 160.3C263.1 165.4 266 172.4 260.3 182.2L205.8 282.4C204.1 269.7 203.9 257.3 203.9 248C203.9 219.2 205.9 159.1 248 159.1ZM288.8 205.3C291.7 220.7 292.1 236.7 292.1 248C292.1 276.9 290.1 336.9 248 336.9C234.5 336.9 215.4 329.2 227.9 310.5L288.8 205.3Z",
    fill: "#BE366C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeCommonZero);
export default __webpack_public_path__ + "static/media/creative-common-zero.077f6615beac48df6eff8af97ef0c214.svg";
export { ForwardRef as ReactComponent };